import { render, staticRenderFns } from "./FormSummary.vue?vue&type=template&id=bc68f5c0&"
import script from "./FormSummary.vue?vue&type=script&lang=js&"
export * from "./FormSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports